import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "circle-half-filled-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", transform: "translate(1.5 1.5)" },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 0v3.77a3.23 3.23 0 1 0 0 6.46V14A7 7 0 0 1 7 0Z" }),
        React.createElement("circle", { cx: 7, cy: 7, r: 6.5, stroke: "currentColor" }),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 10.23a3.23 3.23 0 1 0 0-6.46v6.46Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
